<template>
  <div class="users-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'users-page',
}
</script>
